import React from 'react';

const Times = ({ style }) => {
    return (
        <svg
            viewBox="0 0 516 516"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="inner-times y"
            style={style}
        >
            <path
                d="M20.5757 20.5757C47.9556 -6.80422 92.3472 -6.80422 119.727 20.5757L494.614 395.462C521.994 422.842 521.994 467.234 494.614 494.614C467.234 521.994 422.842 521.994 395.462 494.614L20.5757 119.727C-6.80419 92.3472 -6.80421 47.9556 20.5757 20.5757Z"
                fill="#651FFF"
            />
            <path
                d="M21.3864 494.756C-5.99353 467.376 -5.99353 422.985 21.3864 395.605L396.273 20.7184C423.653 -6.66147 468.044 -6.66149 495.424 20.7184C522.804 48.0983 522.804 92.4899 495.424 119.87L120.538 494.756C93.1579 522.136 48.7663 522.136 21.3864 494.756Z"
                fill="#651FFF"
            />
        </svg>
    );
};

export default Times;
